import React from "react";
import { useLang } from "../../i18n/LanguageContext";
import { Check, ChevronDown } from "lucide-react";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "../ui/dropdown-menu";

export const LanguageSelector = ({ compact = false }) => {
  const { lang, setLang, languages } = useLang();
  const current = languages.find((l) => l.code === lang);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        data-testid="navbar-lang-select"
        className="inline-flex items-center gap-1.5 rounded-full border border-slate-200 bg-slate-50 px-3 py-1.5 text-sm font-medium text-slate-700 transition-colors hover:bg-slate-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-sky-500/50"
      >
        <span className="font-mono">{current?.label}</span>
        <ChevronDown className="h-3.5 w-3.5 text-slate-500" />
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="tw-glass min-w-[10rem] border border-slate-200 text-slate-700"
      >
        {languages.map((l) => (
          <DropdownMenuItem
            key={l.code}
            data-testid={`lang-option-${l.code}`}
            onClick={() => setLang(l.code)}
            className="flex cursor-pointer items-center justify-between gap-3 focus:bg-slate-100 focus:text-slate-900"
          >
            <span>{l.name}</span>
            {lang === l.code && <Check className="h-4 w-4 text-blue-700" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
